import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Divider,
  Grid2,
  IconButton,
  Link,
  Tab,
  Tabs,
  Typography
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReferFriendsBanner from "Assets/Images/ReferFriendsBanner.png";
import { ReactComponent as StarIcon } from "Assets/Icons/Curriculum/StarIcon.svg";
import { ReactComponent as DownloadIcon } from "Assets/Icons/Classroom/DownloadIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import profileImg from "Assets/Images/ProfileImage.png";
import { ReactComponent as PlusIcon } from "Assets/Icons/Settings/PlusIcon.svg";
import WorkStepOne from "Assets/Images/WorkStepOne.png";
import workStepTwo from "Assets/Images/workStepTwo.png";
import WorkStepThree from "Assets/Images/WorkStepThree.png";
import WorkStepFour from "Assets/Images/WorkStepFour.png";
import EVoucher from "Assets/Images/EVoucher.png";
import WhyRefer from "Assets/Images/WhyRefer.png";
import { ReactComponent as CalculatorIcon } from "Assets/Icons/Referral/CalculatorIcon.svg";
import { ReactComponent as CoinIcon } from "Assets/Icons/Referral/CoinIcon.svg";
import { ReactComponent as CallBackICon } from "Assets/Icons/Referral/CallBackIcon.svg";
import { ReactComponent as FormDetailIcon } from "Assets/Icons/Referral/FormDetailIcon.svg";
import { ReactComponent as ExpandIcon } from "Assets/Icons/Leaderboard/ExpandIcon.svg";
import { ReactComponent as CollapseIcon } from "Assets/Icons/Leaderboard/CollapseIcon.svg";
import Loader from "Components/Common/Loader";
import PrimaryTable from "Components/Common/PrimaryTable";
import StartReferringDialog from "Components/Referral/StartReferringDialog";
import AddFriendsDetail from "Components/Referral/AddFriendsDetail";
import AddFriendsProgram from "Components/Referral/AddFriendsProgram";
import RewardCalculator from "Components/Referral/RewardCalculator";
import RewardsCalculatorSection from "Components/Referral/RewardsCalculatorSection";
import { getReferralReward, getProgram, addUserRequest } from "Slices/thunks";

const styles = (theme) => ({
  padding: "24px 0px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
});



const InviteFriends = () => {
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState(0);
  const [referralTab, setReferralTab] = useState("referred");
  const [startReferring, setStartReferring] = useState(false);
  const [addFriend, setAddFriend] = useState(false);
  const [addProgram, setAddProgram] = useState(false);
  const [openRewardCalc, setOpenRewardCalc] = useState(false);
  const [friendDetails, setFriendDetails] = useState([]);

  const referredListRef = useRef(null);

  // const [friendDetails, setFriendDetails] = useState([{FullName: 'Abhay'}, {FullName: 'Raju'}, {FullName: 'Abhay'}, {FullName: 'Raju'}, {FullName: 'Abhay'}, {FullName: 'Raju'}]);

  const [expanded, setExpanded] = useState(1);

  const { isLoading, ReferralReward, ReferredUser, ReferredUserYetToJoin, EnrolledUser, Translation } = useSelector((state) => ({
    isLoading: state.ReferralReward.loading,
    ReferralReward: state.ReferralReward.referralReward,
    ReferredUser: state.ReferralReward.referredUser,
    ReferredUserYetToJoin: state.ReferralReward.referredUserYetToJoin,
    EnrolledUser: state.ReferralReward.enrolledUser,
    Translation: state.Translation.translation?.Referral || {},
  }));

  const handleChange = (value) => (e, newExpanded) => {
    if (newExpanded) {
      setExpanded(value);
    } else {
      setExpanded();
    }
  };

  const handleWhatsAppShare = () => {
    // const message = `Check out this link! ${ReferralReward[currentTab]?.ReferralCode}`;
    // const whatsAppLink = `https://wa.me/?text=${encodedMessage}`;
    // const mobileWhatsAppLink = `whatsapp://send?text=${encodedMessage}`;
    const referralCode = ReferralReward[currentTab]?.ReferralCode || 'ABC123';
    const message = Translation?.ShareOnWhatsappText?.replaceAll('XXX', referralCode)
    const encodedMessage = encodeURIComponent(message);
  
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const whatsAppLink = isMobile ? `whatsapp://send?text=${encodedMessage}` : `https://wa.me/?text=${encodedMessage}`;
  
    if (isMobile) {
      window.location.href = whatsAppLink;
    } else {
      window.open(whatsAppLink, '_blank');
    }
  };

  const handleAddUserRequest = () => {
    dispatch(addUserRequest({ DoubtID: null, IsCalled: false }))
  }

  const checkStatus = () => {
    // referredListRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    const top = referredListRef.current.offsetTop;
    window.scrollTo({
      top,
      left: 0, 
      behavior: "smooth",
    });
    setReferralTab('referred');
    setAddProgram(false);
  };

  const handleTermsAndConditions = () => {
    window.open(Translation?.TermsConditionDocumentUrl, "_blank");
  }

  const workSteps = [
    {
      image: WorkStepOne,
      title: (
        <Typography variant="title" fontWeight={500}>
          {Translation?.ConnectWith}{" "}
          <Link href="#" underline="none">
            {Translation?.ReferralManager}
          </Link>
        </Typography>
      ),
      desc: (
        <Typography color="secondary.light">
          {Translation?.ConnectReferralManager}{" "}
          <Link href="#" underline="none">
            {" "}
            {Translation?.RequestingCallback}{" "}
          </Link>{" "}
            {Translation?.CallingDirectly}{" "}
          <Link href="#" underline="none">
            {" "}
            {Translation?.ShowContact}{" "}
          </Link>
        </Typography>
      ),
    },
    {
      image: workStepTwo,
      title: (
        <Typography variant="title" fontWeight={500}>
          {Translation?.ReferFriend}
        </Typography>
      ),
      desc: (
        <Typography color="secondary.light">
          {Translation?.ReferralManagerDescription}
        </Typography>
      ),
    },
    {
      image: WorkStepThree,
      title: (
        <Typography variant="title" fontWeight={500}>
          {Translation?.YourFriendJoinCodedPlus}
        </Typography>
      ),
      desc: (
        <Typography color="secondary.light">
          {Translation?.FriendInterestedJoinCodedPlus}
        </Typography>
      ),
    },
    {
      image: WorkStepFour,
      title: (
        <Typography variant="title" fontWeight={500}>
          {Translation?.ConnectWith}{" "}
          <Link href="#" underline="none">
            {Translation?.ReferralManager}
          </Link>
        </Typography>
      ),
      desc: (
        <Typography color="secondary.light">
          {Translation?.EarnIncredibleReward}
          <Link href="#" underline="none">
            {" "}
            {Translation?.CheckReward}
          </Link>{" "}
        </Typography>
      ),
    },
  ];

  const referOptions = [
    Translation?.AnybodyLookingForWork,
    Translation?.WishingToMoveCareer,
    Translation?.WantToUpgradeSkills,
    Translation?.BeginningCareerProgramming,
    Translation?.LearningCodingLanguage,
    Translation?.SeekingDegreeProgramming,
  ];

  const userColumns = [
     {
      label: Translation?.SerialNo,
      accessor: "SerialNo",
      align: "center",
    },
    {
      type: "NameWithPhone",
      label: Translation?.Name,
      accessor: "FullName",
      align: "center",
    },
    {
      type: "Date",
      label: Translation?.DateReferred,
      accessor: "CreatedAt",
      align: "center",
    },
    {
      label: Translation?.Program,
      accessor: "Program",
      align: "center",
    },
    {
      label: Translation?.CurrentStatus,
      accessor: "CurrentStatus",
      align: "center",
    }
  ]

  const referralColumns = [
    { label: Translation?.Referrals, accessor: "referrals" },
    { label: Translation?.Cash, accessor: "cash" },
    {
      accessor: "plus",
      label: "",
    },
    {
      accessor: "coins",
      label: Translation?.Coins,
    },
    {
      accessor: "plus",
      label: "",
    },
    {
      accessor: "vouchers",
      label: Translation?.EVouchers,
    },
  ];

  const referralData = [
    {
      referrals: 1,
      cash: `${ReferralReward?.CurrencyCode} ${ReferralReward?.Cash}`,
      plus: (
        <PrimaryIcon
          width="14px"
          variant="light"
          height="14px"
          icon={PlusIcon}
        />
      ),
      coins: ReferralReward?.Coin,
      vouchers: (
        <Box display={"flex"} alignItems={"center"} gap={"10px"}>
          <img width={"35px"} src={EVoucher} alt="E-Vouchers" />
          <Box display={"flex"} flexDirection={"column"}>
            <Typography variant="subtitle" fontWeight={500}>
              {`${ReferralReward?.CurrencyCode} ${ReferralReward?.Voucher}`}
            </Typography>
            <Typography color="secondary.light">{Translation?.Worth} {Translation?.EVouchers}</Typography>
          </Box>
        </Box>
      ),
    },
    {
      referrals: 1,
      cash: `${ReferralReward?.CurrencyCode} ${ReferralReward?.Cash}`,
      plus: (
        <PrimaryIcon
          width="14px"
          variant="light"
          height="14px"
          icon={PlusIcon}
        />
      ),
      coins: ReferralReward?.Coin,
      vouchers: (
        <Box display={"flex"} alignItems={"center"} gap={"10px"}>
          <img width={"35px"} src={EVoucher} alt="E-Vouchers" />
          <Box display={"flex"} flexDirection={"column"}>
            <Typography variant="subtitle" fontWeight={500}>
              {`${ReferralReward?.CurrencyCode} ${ReferralReward?.Voucher}`}
            </Typography>
            <Typography color="secondary.light">{Translation?.Worth} {Translation?.EVouchers}</Typography>
          </Box>
        </Box>
      ),
    },
    {
      referrals: 1,
      cash: `${ReferralReward?.CurrencyCode} ${ReferralReward?.Cash}`,
      plus: (
        <PrimaryIcon
          width="14px"
          variant="light"
          height="14px"
          icon={PlusIcon}
        />
      ),
      coins: ReferralReward?.Coin,
      vouchers: (
        <Box display={"flex"} alignItems={"center"} gap={"10px"}>
          <img width={"35px"} src={EVoucher} alt="E-Vouchers" />
          <Box display={"flex"} flexDirection={"column"}>
            <Typography variant="subtitle" fontWeight={500}>
              {`${ReferralReward?.CurrencyCode} ${ReferralReward?.Voucher}`}
            </Typography>
            <Typography color="secondary.light">{Translation?.Worth} {Translation?.EVouchers}</Typography>
          </Box>
        </Box>
      ),
    },
    {
      referrals: 1,
      cash: `${ReferralReward?.CurrencyCode} ${ReferralReward?.Cash}`,
      plus: (
        <PrimaryIcon
          width="14px"
          variant="light"
          height="14px"
          icon={PlusIcon}
        />
      ),
      coins: ReferralReward?.Coin,
      vouchers: (
        <Box display={"flex"} alignItems={"center"} gap={"10px"}>
          <img width={"35px"} src={EVoucher} alt="E-Vouchers" />
          <Box display={"flex"} flexDirection={"column"}>
            <Typography variant="subtitle" fontWeight={500}>
              {`${ReferralReward?.CurrencyCode} ${ReferralReward?.Voucher}`}
            </Typography>
            <Typography color="secondary.light">{Translation?.Worth} {Translation?.EVouchers}</Typography>
          </Box>
        </Box>
      ),
    },
  ];

  const faqs = [
    {
      question: Translation?.HowReferFriend,
      answer: [
        {
          type: "subtitle",
          value: Translation?.ReferMentionedBelow,
        },
        {
          type: "ul",
          value: [
            Translation?.RequestReferNow,
            Translation?.AddRefereeDetails,
            Translation?.ShareReferralCodeWithFriend,
          ],
        },
        {
          type: "link",
          value: Translation?.ReferNow,
        },
      ],
    },
    {
      question: Translation?.EarnThroughReferral,
      answer: [
        {
          type: "category",
          // value: [
          //   "For every successful referral shared pre-SET attempt, you will receive Rs. 10,000 in your bank account, and Rs. 2,000 e-voucher.",
          //   "For every successful referral shared post-SET attempt, you will receive Rs. 5,000 in your bank account, and Rs. 1,000 e-voucher.",
          // ],
          value: [],
        },
        {
          type: "link",
          value: Translation?.ReferNow,
        },
      ],
    },
    {
      question:
        Translation?.FAQQuestion,
      answer:
        Translation.FAQAnswer,
    },
  ];

  useEffect(() => {
    dispatch(getReferralReward());
    dispatch(getProgram())
  }, [])


  return (
    isLoading ? <Loader /> :
    <>
      <Grid2 sx={styles}>
        <Box
          display={"flex"}
          alignItems={"center"}
          gap={"20px"}
          justifyContent={"space-between"}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={"24px"}
            alignItems={"start"}
          >
            <Box>
              <Typography fontWeight={500} fontSize={"28px"}>
                {Translation?.ReferYourFriend}
              </Typography>
              <Typography
                sx={(theme) => ({
                  "& span": { color: theme.palette.primary.main },
                })}
                fontWeight={500}
                fontSize={"28px"}
              >
                {Translation?.EarnUpto} <span>{`${ReferralReward[currentTab]?.CurrencyCode} ${parseInt(ReferralReward[currentTab]?.Cash || 0) + parseInt(ReferralReward[currentTab]?.Voucher || 0)}`}</span> {Translation?.EveryEnrollment}
              </Typography>
            </Box>
            <Box
              sx={(theme) => ({
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                "&>span": {
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                },
              })}
            >
              { Array.isArray(ReferralReward) && ReferralReward.map((category) => {
                return (
                  <Typography
                    variant="subtitle"
                    fontWeight={500}
                    color="secondary.light"
                  >
                    <PrimaryIcon icon={StarIcon} color="primary" />
                    {Translation?.YouReferAFriend} {category?.Name}. {Translation?.YouGet} {category?.CurrencyCode} {category?.Cash} {Translation?.CashVoucher} {`${category?.CurrencyCode} ${category?.Voucher} + ${category?.Coin}`} {Translation?.CodedCoins}. {Translation?.GetOffCourse?.replace('{XXX}', category?.ReferendAmount)}
                  </Typography>
                )
              })

              }
              {/* <Typography
                variant="subtitle"
                fontWeight={500}
                color="secondary.light"
              >
                <PrimaryIcon icon={StarIcon} color="primary" />
                If you refer a friend Post-SET- You get ₹5000 cash + Vouchers
                worth ₹1000 + 200 Scaler coins
              </Typography>
              <Typography
                variant="subtitle"
                fontWeight={500}
                color="secondary.light"
              >
                <PrimaryIcon icon={StarIcon} color="primary" />
                {Translation?.GetOffCourse}
              </Typography> */}
              <Typography color="secondary.light">
                {Translation?.TermsConditionsApply}
              </Typography>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
              <Box display={"flex"} gap={"16px"}>
                <Button
                  onClick={() => setStartReferring(true)}
                  variant="contained"
                >
                  {(ReferredUser?.length > 0 || EnrolledUser?.length > 0) ? Translation?.ReferAgain : Translation?.StartReferringNow}
                </Button>
                {/* <Button
                  onClick={() => setOpenRewardCalc(true)}
                  variant="outlined"
                  color="secondary"
                >
                  Rewards calculator
                </Button> */}
              </Box>
              <Box display={"flex"} gap={"8px"} alignItems={"center"}>
                <AvatarGroup spacing="medium">
                  <Avatar
                    sx={{ width: 26, border: "none !important", height: 26 }}
                    alt="Remy Sharp"
                    src={profileImg}
                  >
                    S
                  </Avatar>
                  <Avatar
                    sx={{ width: 26, border: "none !important", height: 26 }}
                    alt="Travis Howard"
                    src={profileImg}
                  >
                    T
                  </Avatar>
                  <Avatar
                    sx={{ width: 26, border: "none !important", height: 26 }}
                    alt="Cindy Baker"
                    src={profileImg}
                  >
                    B
                  </Avatar>
                </AvatarGroup>
                <Typography color="secondary.light">
                  {Translation?.CodiesReferred?.replace('{XXX}', ReferralReward[currentTab]?.Codies)?.replace('{YYY}', ReferralReward[currentTab]?.Learners)}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <img
              style={{ maxHeight: "350px" }}
              src={ReferFriendsBanner}
              alt={Translation?.ReferYourFriends}
            />
          </Box>
        </Box>
        <Box
          sx={(theme) => ({
            border: `1px solid ${theme.palette.border.blue}`,
            borderRadius: "8px",
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          })}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={"8px"}
              alignItems={"start"}
            >
              <Typography variant="subtitle" fontWeight={500}>
                {Translation?.EarnByReferring}
              </Typography>
              <Button
                startIcon={<PrimaryIcon icon={DownloadIcon} color="primary" />}
                variant="outlined"
                onClick={() => window.open(ReferralReward[currentTab]?.DocumentURL, "_blank")}
              >
                {Translation?.ViewReferralRewardDetails}
              </Button>
            </Box>
            <Button variant="contained" color="error" onClick={handleAddUserRequest} >
              {Translation?.TalkToReferralManager}
            </Button>
          </Box>
          <RewardsCalculatorSection currentTab={currentTab} setCurrentTab={setCurrentTab} />
        </Box>
        <Box
          sx={(theme) => ({
            background: theme.palette.background.default,
            borderRadius: "8px",
            padding: "16px",
          })}
        >
          <Typography
            display={"flex"}
            variant="title"
            fontWeight={500}
            justifyContent={"center"}
          >
            {Translation?.HowItWork}
          </Typography>
          <Grid2 mt={"20px"} container spacing={2}>
            {workSteps?.map((item, i) => {
              return (
                <Grid2
                  sx={(theme) => ({
                    border: `1px solid ${theme.palette.border.blue}`,
                    borderRadius: "8px",
                    padding: "16px",
                    background: theme.palette.white.main,
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    alignItems: "start",
                  })}
                  size={3}
                  key={`work_${i}`}
                >
                  <img width={"100%"} src={item?.image} alt="Work Steps" />
                  {item?.title}
                  {item?.desc}
                </Grid2>
              );
            })}
          </Grid2>
        </Box>
        {/* <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="title" fontWeight={500}>
            Rewards you get for successful referrals
          </Typography>
          <Button
            variant="contained"
            onClick={() => setOpenRewardCalc(true)}
            startIcon={<PrimaryIcon icon={CalculatorIcon} fill={false} />}
          >
            Rewards Calculator
          </Button>
        </Box>
        <Grid2 container spacing={2}>
          {[...Array(2)]?.map((item, i) => {
            return (
              <Grid2 key={`rewards_${i}`} size={6}>
                <Typography
                  display={"flex"}
                  mb="10px"
                  variant="subtitle"
                  fontWeight={500}
                >
                  For learners whom you referred Pre-SET
                </Typography>
                <PrimaryTable columns={referralColumns} data={referralData} />
              </Grid2>
            );
          })}
          <Typography color="secondary.light">
            Note: If you successfully refer 15 or more learners in a single
            cohort, you'll receive a flat rate of ₹5,000 for every successful
            referral starting from the 16th referral onwards.
          </Typography>
        </Grid2>
        <Grid2 container spacing={2}>
          <Grid2 size={6}>
            <Typography
              display={"flex"}
              mb="10px"
              variant="subtitle"
              fontWeight={500}
              color="primary"
            >
              Coded School of Technology Undergrad Program
            </Typography>
            <PrimaryTable
              columns={[
                {
                  label: "Test completed by Referrals",
                  accessor: "test",
                  align: "center",
                },
                {
                  label: "Amazon Voucher",
                  accessor: "voucher",
                  align: "center",
                },
              ]}
              data={[{ test: 1, voucher: 1000 }]}
            />
          </Grid2>
          <Grid2 size={6}>
            <Typography
              display={"flex"}
              mb="10px"
              variant="subtitle"
              fontWeight={500}
              color="primary"
            >
              Coded School of Business
            </Typography>
            <PrimaryTable
              columns={[
                {
                  label: "Test completed by Referrals",
                  accessor: "test",
                  align: "center",
                },
                {
                  label: "Successful Enrolment",
                  accessor: "enrolment",
                  align: "center",
                },
              ]}
              data={[
                {
                  test: "₹ 500 Amazon Voucher",
                  enrolment: "₹ 40,000 Cash Reward",
                },
              ]}
            />
          </Grid2>
        </Grid2> */}
        <Box
          sx={(theme) => ({
            background: "#FFF7E8",
            borderRadius: "8px",
            padding: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          })}
        >
          <Typography display={"flex"} alignItems={"center"}>
            {Translation?.GetAdditional} &nbsp;{" "}
            <PrimaryIcon height="16px" width="16px" icon={CoinIcon} /> &nbsp;
            {ReferralReward[currentTab]?.Coin} {Translation?.CoinThroughReferralManager}
          </Typography>
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<PrimaryIcon icon={DownloadIcon} />}
            onClick={() => window.open(ReferralReward[currentTab]?.DocumentURL, "_blank")}
          >
            {Translation?.ViewReferralRewardDetails}
          </Button>
        </Box>
        <Box
          sx={(theme) => ({
            background: theme.palette.background.default,
            borderRadius: "8px",
            padding: "16px",
          })}
        >
          <Typography
            display={"flex"}
            variant="title"
            fontWeight={500}
            justifyContent={"center"}
          >
            {Translation?.WhoCanIRefer}
          </Typography>
          <Grid2 mt={"16px"} mb="16px" container spacing={2}>
            {referOptions?.map((item, i) => {
              return (
                <Grid2
                  sx={(theme) => ({
                    border: `1px solid ${theme.palette.border.blue}`,
                    borderRadius: "8px",
                    padding: "16px",
                    background: theme.palette.white.main,
                    textAlign: "center",
                  })}
                  size={2}
                  key={`work_${i}`}
                >
                  {item}
                </Grid2>
              );
            })}
          </Grid2>
          <Typography textAlign={"center"} color="secondary.light">
            {Translation?.YourFriendWillSave}{" "}
            <Typography fontWeight={500} variant="subtitle" color="secondary">
              {" "}
              {`${ReferralReward[currentTab]?.CurrencyCode} ${parseInt(ReferralReward[currentTab]?.Cash || 0) + parseInt(ReferralReward[currentTab]?.Voucher || 0)}`}{" "}
            </Typography>{" "}
            {Translation?.SignUpCourseOnCodedPlus}
          </Typography>
        </Box>
        <Grid2 container spacing={2}>
          <Grid2
            size={6}
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              "& ul": {
                marginBlockStart: "0px",
                marginBlockEnd: "0px",
                paddingInlineStart: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                color: theme.palette.secondary.light,
                "& span": {
                  fontWeight: 500,
                },
              },
            })}
          >
            <Typography variant="title" fontWeight={500}>
              {" "}
              {Translation?.WhyShouldIRefer}
            </Typography>
            <img src={WhyRefer} alt={Translation?.WhyShouldIRefer} />
            {/* <ul>
              <li>
                <span> Help individuals </span> discover a top-notch learning
                experience at Scaler
              </li>
              <li>
                <span> Receive rewards and good karma points </span>for
                referring friends or colleagues to Scaler
              </li>
              <li>
                Become an enabler for individuals to
                <span> enhance their career prospects</span> through the Scaler
                learning program
              </li>
              <li>
                <span> Empower individuals </span>to get the right kind
                of mentorship via Coded top-rated mentors
              </li>
              <li>
                <span> Become a co-creator </span>of the {" "}
                <span>Coded community </span>with top professionals from across
                the tech industry
              </li>
            </ul> */}
            <Box dangerouslySetInnerHTML={{__html: Translation?.ReferralDescriptionList}}>
            </Box>
          </Grid2>
          <Grid2
            sx={(theme) => ({
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            })}
            size={6}
          >
            <Typography variant="title" fontWeight={500}>
              {Translation?.ReferralStatus}
            </Typography>
            <Divider />

            <Tabs
              type="button"
              ref={referredListRef}
              value={referralTab}
              TabIndicatorProps={{ hidden: true }}
              sx={{ marginBottom: "0px", minHeight: "35px" }}
              onChange={(e, value) => setReferralTab(value)}
            >
              <Tab value={"referred"} label={Translation?.Referred} />
              <Tab value={"yet"} label={Translation?.ReferralsYetToJoin} />
              <Tab value={"enrolled"} label={Translation?.EnrolledReferrals} />
            </Tabs>
            { referralTab === "referred" ? 
              Array.isArray(ReferredUser) && ReferredUser.length > 0 ?
                <PrimaryTable
                  columns={userColumns}
                  data={ReferredUser}
                  translation={Translation || {}}
                /> :
               <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                gap={"8px"}
                height={"-webkit-fill-available"}
                justifyContent={"center"}
              >
                <Typography variant="subtitle" fontWeight={500}>
                  {Translation?.NoReferralsYet}
                </Typography>
                <Box display={"flex"} alignItems={"center"} gap={"10px"}>
                  <AvatarGroup spacing="medium">
                    <Avatar
                      sx={{ width: 26, border: "none !important", height: 26 }}
                      alt="Remy Sharp"
                      src={profileImg}
                    >
                      S
                    </Avatar>
                    <Avatar
                      sx={{ width: 26, border: "none !important", height: 26 }}
                      alt="Travis Howard"
                      src={profileImg}
                    >
                      T
                    </Avatar>
                    <Avatar
                      sx={{ width: 26, border: "none !important", height: 26 }}
                      alt="Cindy Baker"
                      src={profileImg}
                    >
                      B
                    </Avatar>
                  </AvatarGroup>
                  <Typography color="secondary.light">
                    {Translation?.CodiesReferred?.replace('{XXX}', ReferralReward[currentTab]?.Codies)?.replace('{YYY}', ReferralReward[currentTab]?.Learners)}
                  </Typography>
                </Box>
                <Button color="error" variant="contained" onClick={handleWhatsAppShare}>
                  {Translation?.ShareOnWhatsapp}
                </Button>
              </Box> : 
              referralTab === "yet" ? 
                <PrimaryTable
                  columns={userColumns}
                  data={ReferredUserYetToJoin}
                  translation={Translation || {}}
                /> :

              referralTab === "enrolled" ? 
                <PrimaryTable
                  columns={userColumns}
                  data={EnrolledUser}
                  translation={Translation || {}}
                /> : <></>

            }


            
          </Grid2>
        </Grid2>
        <Box>
          <Typography
            display={"flex"}
            mb="16px"
            variant="title"
            fontWeight={500}
          >
            {Translation?.GetInTouch}
          </Typography>
          <Grid2
            sx={(theme) => ({
              "&>div": {
                border: `1px solid ${theme.palette.border.blue}`,
                borderRadius: "8px",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "start",
                "& button": {
                  marginTop: "auto",
                },
                "& ol": {
                  marginBlockStart: "0px",
                  marginBlockEnd: "0px",
                  paddingInlineStart: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                },
              },
            })}
            container
            spacing={2}
          >
            <Grid2 size={4}>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                width={"100%"}
              >
                <Typography fontWeight={500}>{Translation?.RequestACallback}</Typography>
                <PrimaryIcon
                  icon={CallBackICon}
                  variant="light"
                  height="30px"
                  width="30px"
                />
              </Box>
              <Typography color="secondary.light">
                {Translation?.ReferralManagerCallYou}
              </Typography>
              <Button variant="contained" color="error" onClick={handleAddUserRequest}>
                {Translation?.WantACallback}
              </Button>
            </Grid2>
            <Grid2 size={4}>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                width={"100%"}
              >
                <Typography fontWeight={500}>{Translation?.AddFriendDetails}</Typography>
                <PrimaryIcon
                  icon={FormDetailIcon}
                  variant="light"
                  height="30px"
                  width="30px"
                />
              </Box>
              <Typography color="secondary.light">
                {Translation?.ShareFriendDetails}
              </Typography>
              <Button
                onClick={() => {
                  setFriendDetails([]);
                  setAddFriend(true)
                }}
                variant="contained"
                color="error"
              >
                {Translation?.AddFriendDetails}
              </Button>
            </Grid2>{" "}
            <Grid2 size={4}>
              <Box>
                <Typography fontWeight={500}>{Translation?.TermsAndConditions}</Typography>
              </Box>
              <Typography color="secondary.light">
                {Translation?.TermAndConditionsReferralPrograms}
              </Typography>
              <ol>
                <li>
                  <Link onClick={handleTermsAndConditions} sx={{cursor: "pointer"}} color="secondary">
                    {Translation?.CodedWorkingProfessionalCourses}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleTermsAndConditions} sx={{cursor: "pointer"}} color="secondary">
                    {Translation?.CodedSchoolOfTechnology}
                  </Link>
                </li>
                <li>
                  <Link onClick={handleTermsAndConditions} sx={{cursor: "pointer"}} color="secondary">
                    {Translation?.CodedSchoolOfBusiness}
                  </Link>
                </li>
              </ol>
            </Grid2>
          </Grid2>
        </Box>
        <Box mb="50px" display={"flex"} flexDirection={"column"} gap={"16px"}>
          <Typography variant="title" fontWeight={500}>
            {Translation?.FrequentlyAskedQuestions}
          </Typography>
          {faqs?.map((item, i) => {
            const isOpen = expanded == i + 1;
            return (
              <Accordion
                elevation={0}
                bordered
                expanded={isOpen}
                onChange={handleChange(i + 1)}
              >
                <AccordionSummary
                  expandIcon={
                    <IconButton filled>
                      {" "}
                      <PrimaryIcon
                        color="white"
                        icon={isOpen ? CollapseIcon : ExpandIcon}
                        width="16px"
                        height="16px"
                      />{" "}
                    </IconButton>
                  }
                >
                  <Typography fontWeight={500} variant="subtitle">
                    {item?.question}
                  </Typography>{" "}
                </AccordionSummary>
                <AccordionDetails primary>
                  <Typography>
                    {typeof item?.answer == "string"
                      ? item?.answer
                      : item?.answer?.map((ans, i) => {
                          return ans?.type == "desc" ? (
                            ans?.value
                          ) : ans?.type == "subtitle" ? (
                            <Typography fontWeight={500}>
                              {" "}
                              {ans?.value}{" "}
                            </Typography>
                          ) : ans?.type == "link" ? (
                            <Link href="#" underline="none" fontWeight={500}>
                              {" "}
                              {ans?.value}{" "}
                            </Link>
                          ) : ans?.type == "category" ? (
                            <ul>
                              { Array.isArray(ReferralReward) && ReferralReward.map((category, index) => {
                                return (
                                  <li key={`li${index}`}>{Translation?.FAQReferredCategory?.replace("AAA", category.Name)?.
                                    replaceAll("BBB", category.CurrencyCode)?.
                                    replaceAll("CCC", category.Cash)?.
                                    replaceAll("DDD", category.Voucher)}</li>
                                );
                                })
                              }

                            </ul>
                          ): (
                            <ul>
                              {ans?.value?.map((li, i) => {
                                return <li key={`li${i}`}> {li} </li>;
                              })}
                            </ul>
                          );
                        })}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      </Grid2>
      <StartReferringDialog
        open={startReferring}
        setOpen={setStartReferring}
        currentTab={currentTab}
        handleAddUserRequest={handleAddUserRequest}
        handleWhatsAppShare={handleWhatsAppShare}
        addFriend={() => {
          setStartReferring(false);
          setFriendDetails([]);
          setAddFriend(true);
        }}
      />
      <AddFriendsDetail open={addFriend} setOpen={setAddFriend} friendDetails={friendDetails} setFriendDetails={setFriendDetails} setAddProgram={setAddProgram} />
      <AddFriendsProgram open={addProgram} setOpen={setAddProgram} friendDetails={friendDetails} setFriendDetails={setFriendDetails} checkStatus={checkStatus} />
      <RewardCalculator open={openRewardCalc} setOpen={setOpenRewardCalc} />
    </>
  );
};

export default InviteFriends;
